import { liningEmbroidery } from 'src/features/atoms/glove/drawer/common/back/embroidery'
import { State } from 'src/types'
import { generateLiningsGradient, startInversion, undoInversion } from 'src/util/canvas'

const lining = (ctx: CanvasRenderingContext2D, color: string): void => {
  ctx.lineWidth = 0.8
  ctx.strokeStyle = '#282828'
  ctx.fillStyle = color

  // 手入れ口部分
  ctx.beginPath()
  ctx.moveTo(256, 465) // 左上
  ctx.quadraticCurveTo(257, 514, 265, 532) // 左下
  ctx.quadraticCurveTo(424, 536, 424, 536) //右下
  ctx.quadraticCurveTo(464, 505, 464, 505) //
  ctx.quadraticCurveTo(475, 461, 432, 442) //
  ctx.quadraticCurveTo(357, 421, 256, 465) //
  const coordinates = { x0: 150, y0: 300, x1: 700, y1: 400 }
  const gradient = generateLiningsGradient(ctx, color, coordinates)
  ctx.fillStyle = gradient

  ctx.fill()
  ctx.stroke()
  ctx.closePath()
}

export const liningDrawerLeftThrow = (ctx: CanvasRenderingContext2D, state: State, canvasWidth: number): void => {
  startInversion(ctx, canvasWidth)
  lining(ctx, state.linings.color)
  undoInversion(ctx, canvasWidth)

  const isEmbroideryOfLiningFirst = state.embroideries.some((x) => x.position.value === 'leatherLiningFirst')
  // 平裏への刺繍
  if (isEmbroideryOfLiningFirst) {
    liningEmbroidery(
      ctx,
      state.embroideries.find((embroidery) => embroidery.position.value === 'leatherLiningFirst'),
      250,
      -15
    )
  }
  const isEmbroideryOfLiningSecond = state.embroideries.some((x) => x.position.value === 'leatherLiningSecond')
  // 平裏への刺繍
  if (isEmbroideryOfLiningSecond) {
    liningEmbroidery(
      ctx,
      state.embroideries.find((embroidery) => embroidery.position.value === 'leatherLiningSecond'),
      255,
      30
    )
  }
}
